export default {
    name: 'interpretation',
    serverName: '/api/v1/agrochemical_calculator/agrochemical_interpretation/',
    apiUrl: '/api/v1/agrochemical_calculator/agrochemical_interpretation/'
};
